import { render, staticRenderFns } from "./ItemListDetail.vue?vue&type=template&id=1bc2bb67&scoped=true&"
import script from "./ItemListDetail.vue?vue&type=script&lang=ts&"
export * from "./ItemListDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ItemListDetail.vue?vue&type=style&index=0&id=1bc2bb67&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc2bb67",
  null
  
)

export default component.exports